import {RoomState} from '../../../../../shared/RoomState'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {UIRoomUserList} from '../../../../shared/scripts/ui_html/room/UIRoomUserList'
import {RoomSessionClientState} from '../../../../../shared/RoomSessionClientState'
import {ViewPopupEditProfile, EditProfileTab} from '../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {PlayerColor} from '@colonist/game-states'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend'
import {UIWProfileUsernameController} from '../header/UIWProfileUsernameController'
import {ViewPopupEditBotProfile} from '../../../../shared/scripts/ui_popup/ViewPopupEditBotProfile'

export class UIWRoomUserListController extends UIRoomUserList {
    private readonly header: HTMLHeadingElement

    constructor() {
        super(document.getElementById('scene_room_player_list') as HTMLDivElement)
        this.header = document.getElementById('scene_room_left_header') as HTMLHeadingElement
    }

    update(newRoomState: RoomState) {
        this.updateHeaderView(newRoomState.getSessionCount(), newRoomState.gameSetting.maxPlayers)
        super.update(newRoomState)
    }

    private updateHeaderView(sessionCount: number, maxPlayers: number) {
        const newText = clientI18n.t('strings:roomPage.notifications.playerCount', {count: sessionCount, maxCount: maxPlayers})
        if(this.header.innerText != newText) this.header.innerText = newText
    }

    // eslint-disable-next-line class-methods-use-this
    protected openEditProfileForPlayer(player: RoomSessionClientState | undefined): void {
        if(player?.isBot) {
            new ViewPopupEditBotProfile({
                usernameController: UIWProfileUsernameController,
                selectColorAction: async(color: PlayerColor) => {
                    if(player == undefined) return
                    SocketLobbySend.clickedRoomSelectColor(player.roomSessionId, color)
                },
                tab: EditProfileTab.Color,
                selectedColor: player?.selectedColor,
                username: player?.username,
            })
            return
        }

        new ViewPopupEditProfile({
            usernameController: UIWProfileUsernameController,
            selectColorAction: async(color: PlayerColor) => {
                if(player == undefined) return
                SocketLobbySend.clickedRoomSelectColor(player.roomSessionId, color)
            },
            tab: EditProfileTab.Color,
            selectedColor: player?.selectedColor,
        })
    }
}
